import React, { useRef, useState, useEffect } from "react";
import AddAPhotoIcon from "@mui/icons-material/AddAPhoto";
import { Close } from "@mui/icons-material";
import { Box, Button, CircularProgress, TextField } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker, TimePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import "dayjs/locale/en-gb";
import AddButtonToPost from "./AddButtonToPost";
import { useDispatch, useSelector } from "react-redux";
import {
  addUpdatePost,
  selectAllPostsError,
  selectAllPostsLoading,
  selectLoadingState,
} from "../../../Store/Gmb/gmbPostSlice";
import {
  selectAccountId,
  selectLocationId,
} from "../../../Store/Gmb/gmbStoreSlice";
import { getPresignedUrl } from "../helper/getImagePresignedUrl";
import { uploadPostImagesToS3 } from "../helper/uploadImageToS3";
import { validateGMBPhoto } from "../helper/validateGMBPhoto";
import AddOfferToPost, { isMoreDomainUrl } from "./AddOfferToPost";
import { toast } from "react-toastify";
import { GMB } from "../../../services/gmbApiConfig";
import axios from "axios";
import Cookies from "js-cookie";
const hasEmptyValues = (obj,type) => {
  console.log("type",type)
console.log("obj",obj)
  return Object.values(obj).some(
    (value) =>
      value === null ||
      value === undefined ||
      (typeof value === "string" && value.trim() === "") ||
      (Array.isArray(value) && value.length === 0) ||
      (typeof value === "object" && hasEmptyValues(value)) // Recursive for nested objects
  );
};

const AddUpdate = ({ topicType, setModalOpen }) => {
  const fileRef = useRef();
  const [fileImage, setFileImage] = useState(null);
  const [fileAsBinary, setFileAsBinary] = useState(null);
  const [postData, setPostData] = useState({});
  const accountId = useSelector(selectAccountId);
  const locationId = useSelector(selectLocationId);
  const isAddingPost = useSelector((state) =>
    selectLoadingState(state, "addUpdatePost")
  );
  const isFetchingPost = useSelector((state) =>
    selectLoadingState(state, "fetchAllPosts")
  );
  const error = useSelector(selectAllPostsError);
  const [loader, setLoader] = useState(false);
  const dispatch = useDispatch();

  const handleFileUpload = () => {
    fileRef.current.click();
  };

  const handleFileChange = async (file) => {
    if (!file) return;

    const validation = await validateGMBPhoto(file);
    if (!validation.isValid) {
      toast.error(validation.error);
      if (fileRef.current) {
        fileRef.current.value = "";
      }
      return;
    }

    const reader = new FileReader();
    reader.onload = (event) => {
      const imageDataUrl = event.target.result;
      setFileImage(imageDataUrl);
      setPostData((prevData) => ({
        ...prevData,
        media: [
          {
            mediaFormat: file.type.startsWith("image/") ? "PHOTO" : null,
            sourceUrl: imageDataUrl,
          },
        ],
      }));
    };
    reader.readAsDataURL(file);
    setFileAsBinary(file);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    if (e.dataTransfer.files?.length > 0) {
      handleFileChange(e.dataTransfer.files[0]);
    }
  };

  const handleAddPost = async () => {
    try {
      console.log("handleAddPost", { postData });
      setLoader(true);

      const validation = await validateGMBPhoto(fileAsBinary);
      if (!validation.isValid) {
        toast.error(validation.error);
        setLoader(false);
        return;
      }

      // Generate the s3 presigned URL
      const presignedUrl = await getPresignedUrl({
        account_id: accountId,
        location_id: locationId,
      });
      console.log("presignedUrl", presignedUrl);
      const key = presignedUrl.fields.key;
      // Upload image to s3
      const response = await uploadPostImagesToS3({
        presignedUrl,
        file: fileAsBinary,
      });
      console.log("response ", response);

      // Get the key and add this as sourceImageUrl
      console.log("upload to gmb response ", response.status == 204);
      // Dispatch the action to add or update the post
      const res = await axios.post(
        `${GMB.ENDPOINTS.POSTS.IMAGES.GET_UPLOADED_PRESIGNED_URLS_POSTS}`,
        {
          account_id: accountId,
          location_id: locationId,
          s3_key: presignedUrl.fields.key,
        },
        {
          headers: {
            Authorization: Cookies.get("ssp_sso_token"),
            "Content-Type": "application/json",
          },
        }
      );
      const sourceUrl = await res.data.sourceUrl;
      console.log("sourceUrl", sourceUrl);
      const updatedPostData = {
        ...postData,
        s3_key: presignedUrl.fields.key,
        media: postData.media
          ? [
              {
                ...postData.media[0],
                sourceUrl: sourceUrl,
              },
            ]
          : [],
      };


      console.log({ accountId, locationId }, { updatedPostData }, { key });
      await dispatch(
        addUpdatePost({
          ...updatedPostData,
          accountId,
          locationId,
          topicType,
          s3Key: presignedUrl.fields.key,
        })
      ).unwrap();
      setLoader(false);
      if (!isAddingPost && !loader && !isFetchingPost) {
        setModalOpen(false);
      }
    } catch (error) {
      console.error("error while adding post", error);
      toast.error(error);
      setLoader(false);
    }
  };

  // Handle DatePicker and TimePicker date formatting
  // const handleDateChange = (newValue, type) => {
  //   const formattedDate = newValue ? dayjs(newValue) : null;
  //   setPostData((prevData) => {
  //     const updatedSchedule = {
  //       ...prevData?.event?.schedule,
  //       [type]: formattedDate
  //         ? {
  //             year: formattedDate.year(),
  //             month: formattedDate.month() + 1,
  //             day: formattedDate.date(),
  //           }
  //         : null,
  //     };
  //     return {
  //       ...prevData,
  //       event: {
  //         ...prevData.event,
  //         schedule: updatedSchedule,
  //       },
  //     };
  //   });
  // };

  const handleDateChange = (newValue, type) => {
    const formattedDate = newValue ? dayjs(newValue) : null;

    setPostData((prevData) => {
      let updatedSchedule = {
        ...prevData?.event?.schedule,
        [type]: formattedDate
          ? {
              year: formattedDate.year(),
              month: formattedDate.month() + 1,
              day: formattedDate.date(),
            }
          : null,
      };

      if (type === "startDate" && prevData?.event?.schedule?.endDate) {
        const endDate = dayjs(
          `${prevData.event.schedule.endDate.year}-${prevData.event.schedule.endDate.month}-${prevData.event.schedule.endDate.day}`
        );

        console.log("endDate", endDate, formattedDate.isAfter(endDate));

        if (formattedDate && formattedDate.isAfter(endDate)) {
          toast.error("Start date cannot be after end date.");
          return prevData; // Prevent updating state
        }
      }

      if (type === "endDate" && prevData?.event?.schedule?.startDate) {
        const startDate = dayjs(
          `${prevData.event.schedule.startDate.year}-${prevData.event.schedule.startDate.month}-${prevData.event.schedule.startDate.day}`
        );

        if (formattedDate && formattedDate.isBefore(startDate)) {
          toast.error("End date cannot be before start date.");
          return prevData; // Prevent updating state
        }
      }

      return {
        ...prevData,
        event: {
          ...prevData.event,
          schedule: updatedSchedule,
        },
      };
    });
  };

  const handleTimeChange = (newValue, type) => {
    const formattedTime = newValue ? dayjs(newValue).format("HH:mm:ss") : null;
    setPostData((prevData) => {
      const updatedSchedule = {
        ...prevData?.event?.schedule,
        [type]: formattedTime
          ? {
              hours: parseInt(formattedTime.split(":")[0], 10),
              minutes: parseInt(formattedTime.split(":")[1], 10),
              seconds: parseInt(formattedTime.split(":")[2], 10),
            }
          : null,
      };
      return {
        ...prevData,
        event: {
          ...prevData.event,
          schedule: updatedSchedule,
        },
      };
    });
  };

  return (
    <div className="mx-auto flex flex-col space-y-4 mt-2 max-h-96 w-full pr-4">
      <div className="flex flex-col items-center justify-center text-gray-800">
        {!fileImage ? (
          <div
            onClick={handleFileUpload}
            onDrop={handleDrop}
            onDragOver={(e) => e.preventDefault()}
            className="h-48 border-2 border-black rounded-lg flex flex-col items-center w-72 cursor-pointer text-sm"
          >
            <input
              ref={fileRef}
              style={{ display: "none" }}
              type="file"
              accept="image/*"
              title="Drag photos or videos here"
              onChange={(e) => handleFileChange(e.target.files[0])}
            />

            <div className="flex flex-col items-center justify-center space-y-4 h-full">
              <p>Drag photos or videos here</p>
              <span>or</span>
              <div className="flex flex-row gap-4 items-center">
                <AddAPhotoIcon className="text-gray-500" />
                <span className="text-blue-500">Select photos or videos</span>
              </div>
            </div>
          </div>
        ) : (
          <div className="relative border-2 border-gray-400 p-4 rounded-xl">
            <img
              src={fileImage}
              alt="preview"
              className="w-48 h-48 object-scale-down"
            />
            <Close
              className="absolute top-0 right-0 cursor-pointer"
              onClick={() => {
                setFileImage(null);
                setPostData((prevData) => ({ ...prevData, media: [] }));
              }}
            />
          </div>
        )}
      </div>

      <div className="flex flex-col space-y-4">
        {topicType !== "STANDARD" && (
          <TextField
            required
            label={`${topicType === "OFFER" ? "Offer Title" : "Event Title"}`}
            sx={{ width: "100%" }}
            value={postData?.event?.title || ""}
            variant="outlined"
            onChange={(e) =>
              setPostData((prevData) => ({
                ...prevData,
                event: {
                  ...prevData.event,
                  title: e.target.value,
                },
              }))
            }
          />
        )}

        <TextField
        required
          label={`${
            topicType === "OFFER"
              ? "Offer Summary"
              : topicType === "STANDARD"
              ? "Description"
              : "Event Summary"
          }`}
          multiline
          rows={4}
          sx={{ width: "100%" }}
          value={postData.summary || ""}
          onChange={(e) =>
            setPostData((prevData) => ({
              ...prevData,
              summary: e.target.value,
            }))
          }
        />
        {topicType === "OFFER" && (
          <AddOfferToPost
            onLinkTextChange={(value) => {
              setPostData((prevData) => ({
                ...prevData,
                offer: {
                  ...prevData.offer,
                  redeemOnlineUrl: value,
                },
              }));
            }}
            onVoucherCodeTextChange={(value) =>
              setPostData((prevData) => ({
                ...prevData,
                offer: {
                  ...prevData.offer,
                  couponCode: value,
                },
              }))
            }
            onTermAndConditionsTextChange={(value) =>
              setPostData((prevData) => ({
                ...prevData,
                offer: {
                  ...prevData.offer,
                  termsConditions: value,
                },
              }))
            }
          />
        )}
        {topicType !== "STANDARD" && (
          <>
            {/* Start Date */}
            <LocalizationProvider
              dateAdapter={AdapterDayjs}
              adapterLocale="en-gb"
            >
              <DatePicker
              required
                label="Start Date"
                sx={{ width: "100%" }}
                format="DD/MM/YYYY"
                value={postData.startDate ? dayjs(postData.startDate) : null} // Ensure Day.js object is passed
                onChange={(newValue) => handleDateChange(newValue, "startDate")}
              />
            </LocalizationProvider>
            {/* Start Time */}
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <TimePicker
              required
                label="Start time "
                sx={{ width: "100%" }}
                value={
                  postData.startTime
                    ? dayjs(postData.startTime, "HH:mm:ss")
                    : null
                } // Ensure time is a Day.js object
                onChange={(newValue) => handleTimeChange(newValue, "startTime")}
              />
            </LocalizationProvider>
            {/* End Date */}
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
              required
                label="End Date"
                sx={{ width: "100%" }}
                format="DD/MM/YYYY"
                value={postData.endDate ? dayjs(postData.endDate) : null} // Ensure Day.js object is passed
                onChange={(newValue) => handleDateChange(newValue, "endDate")}
              />
            </LocalizationProvider>
            {/* End Time */}
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <TimePicker
                label="End time "
                sx={{ width: "100%" }}
                value={
                  postData.endTime ? dayjs(postData.endTime, "HH:mm:ss") : null
                } // Ensure time is a Day.js object
                onChange={(newValue) => handleTimeChange(newValue, "endTime")}
              />
            </LocalizationProvider>
          </>
        )}

        {topicType === "STANDARD" && (
          <AddButtonToPost
            onSelectValue={(value) => {
              setPostData((prevData) => ({
                ...prevData,
                callToAction: value ? {
                  actionType: value
                } : null
              }));
            }}
            onTextValueChange={(data) =>
              setPostData((prevData) => ({
                ...prevData,
                callToAction: {
                  actionType: prevData.callToAction.actionType,
                  url: data.url
                }
              }))
            }
          />
        )}
      </div>

      <div className="flex flex-row justify-end py-4 gap-2 ">
        <Button
          className="bg-blue-500"
          // className="bg-[#F37E2B]"
          onClick={handleAddPost}
          variant="contained"
          disabled={
            Object.keys(postData).length === 0 ||
            isAddingPost ||
            loader ||
            isFetchingPost ||
            hasEmptyValues(postData,topicType)
          }
        >
          {isAddingPost || loader ? (
            <>
              <CircularProgress className="mr-2" size={24} color="inherit" />{" "}
              {/* <span>Adding Post</span> */}
            </>
          ) : (
            "Add Post"
          )}
        </Button>
      </div>
    </div>
  );
};

export default AddUpdate;
